import React from 'react'
import s from './OrderDetails.module.scss'
import { useNavigate } from 'react-router-dom'

const Product = ({ product }: { product: any }) => {
    const navigate = useNavigate()
    return (
        <div className={s.product} onClick={() => navigate(`/product/${product?.id}`)}>
            <img
                src={product?.image}
                className={s.product__img}
                alt=""
            />
            <div className={s.product__info}>
                <div className={s.product__info_name}>{product?.name}</div>
            </div>
        </div>
    )
}

export default Product